  import cn from "classnames";
  import * as S from "./UserInfo.styles";
  import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import TextField from "@material-ui/core/TextField";
  import { Button } from 'ui';
  import { FormControlLabel, Radio, RadioGroup, Paper } from "@mui/material";
  import moment from "moment";
  import { isEmpty, getDefaultId, findStringItem, upperFirst } from "utils/functions";
  import {
    STATUS,
    ROLES,
    FILE_PERMISSION_CHAT,
    DISABLE_ENABLE_BUTTON,
    FILE_PARTNERS_TYPE,
  } from "configs/constants";
  import { Loader, ClickOutside } from "components";
  import {
    filePermission,
    transferChat,
    visitorBan,
    transferAssign,
    getVisitor,
    updateVisitorData,
  } from "socket/socket";
  import { differenceInMinutes } from "./UserInfo.config";
  import { hideModal } from "redux_toolkit/reducers/modals/modalsSlice";


  export const UserInfo = ({chatInfo, canEdit, teamLead}) => {
    const dispatch = useDispatch();
    const teamList = useSelector(({ agents }) => [...agents.partnerTeam.values()]);
    const {list: visitors, visitorPastChats} = useSelector(({ visitors }) => visitors);
    const { currentPartner } = useSelector(({ currentPartner }) => currentPartner);
    const { partnerId, role, _id: currentUserId } = useSelector(({ userPartner }) => userPartner.userData);
    const refSelect = useRef(null);

    const [showDropDown, setShowDropDown] = useState(false);
    const [isDisabled, setIsDisabled] = useState(chatInfo?.transfer);
    const [isOpenedBanContent, setIsOpenedBanContent] = useState(false);
    const [visitorIsBanned, setVisitorIsBanned] = useState(false);
    const [reason, setReason] = useState("");
    const [banDuration, setBanDuration] = useState(1);
    const [file, setfile] = useState( chatInfo.permissionForFile || DISABLE_ENABLE_BUTTON.DISABLE );
    const [time, setTime] = useState(differenceInMinutes(chatInfo.startDate));
    const [visitorInfo, setVisitorInfo] = useState({});
    const [userNote, setUserNote] = useState('');
    let timeoutId = useRef();

    const getPastChats = useCallback((id)=> visitorPastChats.get(id), [visitorPastChats]);

    const getVisitorData = useCallback((vistorId) => {
      const data = visitors.find((visitor) => visitor._id === vistorId) || {};
      setVisitorInfo(data);
      setUserNote(data.note);
    }, [visitors]);

    useEffect(()=> {
      const visitorId = chatInfo?.visitorId || chatInfo?.recipentId;
      if (visitorId) getVisitor(visitorId);
    }, [chatInfo.visitorId, chatInfo.recipentId]);

    useEffect(()=> {
      getVisitorData(chatInfo?.visitorId || chatInfo?.recipentId);
    }, [chatInfo.visitorId, chatInfo.recipentId, getVisitorData, visitors]);

    const pastChats = useMemo(() => getPastChats(visitorInfo?._id)?.length, [visitorInfo?._id, getPastChats]);

    const updateInfoCallBack = useCallback((args)=> {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }

      timeoutId.current = setTimeout(()=> {
        updateVisitorData(chatInfo.visitorId, {
          partnerId,
          note: visitorInfo.note || '',
          ...args
        })
      }, 1000);
      setUserNote(args.note);
    }, [visitorInfo, chatInfo.visitorId, partnerId]);

    const showPermissionButton = currentPartner?.file > 0;

    const assignTo = useCallback(
      (agent) => {
        transferAssign(chatInfo.chatId, agent._id, true);
        dispatch(hideModal());
      },
      [
        chatInfo.chatId,
        dispatch
      ]
    );

    let teammatesToAssign =  useMemo(
      ()=> teamList.filter((agent) => agent._id !== chatInfo.agentId && [STATUS.ONLINE, STATUS.INVISIBLE, STATUS.AWAY].includes(agent.status)
    ),[chatInfo.agentId, teamList]);

    teammatesToAssign = teammatesToAssign.sort((a,b) => (a.status < b.status) ? 1 : ((b.status < a.status) ? -1 : 0));

    const handleTransferChat = useCallback(() => {
      if (role === ROLES.TEAMLEADER) {
        setIsOpenedBanContent(false);
        setShowDropDown(prev => !prev);
      } else {
        setIsDisabled(true);
        transferChat(chatInfo.chatId);
      }
    }, [
      role,
      chatInfo.chatId
    ]);

    const handleSetFilePermission = useCallback(() => {
      const permission = file === DISABLE_ENABLE_BUTTON.DISABLE ? DISABLE_ENABLE_BUTTON.ENABLE : DISABLE_ENABLE_BUTTON.DISABLE;
      setfile(permission);
      filePermission(chatInfo.chatId);
    }, [file, chatInfo.chatId]);

    const handleBanUnbanVisitor = useCallback((data) => {
      let banTime = 0;
      if(!data?.unban) banTime = banDuration;
      visitorBan(visitorInfo._id, banTime, reason);
      setIsOpenedBanContent(false);
      setVisitorIsBanned(!visitorIsBanned);
    }, [banDuration, reason, visitorIsBanned, visitorInfo._id]);


    useEffect(() => {
      setVisitorIsBanned( (visitorInfo.banExpire && moment().isBefore(visitorInfo.banExpire)) || false );
    }, [
      visitorInfo.banExpire
    ]);

    useEffect(() => {
      if (visitorIsBanned) {
        setIsOpenedBanContent(false);
      }
    }, [visitorIsBanned]);

    useEffect(() => {
      setIsDisabled(chatInfo.transfer);
    }, [chatInfo.transfer]);

    useEffect(() => {
      let interval;
      if(!chatInfo.endDate) {
        interval = setInterval(() => {
          const minute = chatInfo.startDate ? differenceInMinutes(chatInfo.startDate):0;
          setTime(minute);
        }, 60000);

        return () => clearInterval(interval);
      }

      setTime(Math.floor((new Date(chatInfo.endDate).getTime() - new Date(chatInfo.startDate).getTime())/60000));
    }, [ chatInfo.timeOnSite, chatInfo.endDate, chatInfo.startDate ]);

    const ua = visitorInfo?.userAgent?.toLowerCase() || '';
    let browserName, browserVersion;
    if (ua.includes('edg/')) {
      browserName = 'Edge';
      browserVersion = visitorInfo.userAgent.match(/edg\/([\.\d]+)/i)?.[1];
    } else if (ua.includes('opr/')) {
      browserName = 'Opera';
      browserVersion = visitorInfo.userAgent.match(/opr\/([\.\d]+)/i)?.[1];
    } else if (ua.includes('chrome/')) {
      browserName = 'Chrome';
      browserVersion = visitorInfo.userAgent.match(/chrome\/([\.\d]+)/i)?.[1];
    } else if (ua.includes('firefox/')) {
      browserName = 'Firefox';
      browserVersion = visitorInfo.userAgent.match(/firefox\/([\.\d]+)/i)?.[1];
    } else if (ua.includes('safari/')) {
      browserName = 'Safari';
      browserVersion = visitorInfo.userAgent.match(/version\/([\.\d]+)/i)?.[1];
    }

    console.log(visitorInfo);

    return (
      <S.UserInfoContainer className="UserInfo">
        {isEmpty(visitorInfo) ? (
          <Loader
            color="primary"
            size={100}
            styles={{ height: "100%", position: "inherit" }}
          />
        ) : (
          <>
            <S.ColumnContainer className="ColumnContainer">
              <TextField
                size="small"
                variant="outlined"
                label="Note"
                multiline={true}
                minRows={13}
                maxRows={13}
                disabled={!canEdit}
                onChange={(e) => updateInfoCallBack({note: e.target.value})}
                value={userNote || ''}
              />
              <S.ActivityContainer>
                <S.ActivityItem>
                  <div>{visitorInfo.visits || "---"}</div>
                  <div>Past visits</div>
                </S.ActivityItem>
                <S.ActivityItem>
                  <div>{pastChats || "---"}</div>
                  <div>Past chats</div>
                </S.ActivityItem>
                <S.ActivityItem>
                  <div>{time} minutes</div>
                  <div>{chatInfo.endDate? 'Chat duration' : 'Time on site'}</div>
                </S.ActivityItem>
              </S.ActivityContainer>
              <S.RowContainer>
                <>{(canEdit || teamLead) &&
                  <>
                    {!chatInfo.endDate && (
                      <>
                        <S.Button
                          disabled={isDisabled}
                          onClick={() => {
                            handleTransferChat();
                          }}
                        >
                          Transfer Chat
                        </S.Button>
                        {showDropDown && (
                          <S.DropDownMenu>
                            {teammatesToAssign.length ? <>
                                <div className={`select select-default`}>
                                  <label>Agent</label>
                                  <select ref={refSelect}>
                                    <option value="">-- select --</option>
                                    {teammatesToAssign.map(agent => <option value={agent._id}>{agent.name}</option>)}
                                  </select>
                                </div>
                                <Button onClick={() => {
                                  if(refSelect.current.value){
                                    const agent = teammatesToAssign.find(i => i._id === refSelect.current.value);
                                    if(agent) assignTo(agent);
                                  }
                                }}>Transfer</Button>
                              </> : 'No active Agents'
                            }
                          </S.DropDownMenu>
                        )}
                      </>
                    )}
                  </>
                }
                  {teamLead && [2,3].includes(chatInfo.status) && (
                      <S.Button
                          disabled={currentPartner?.file === FILE_PARTNERS_TYPE.ENABLE}
                          onClick={handleSetFilePermission}
                      >
                        Attach {FILE_PERMISSION_CHAT[file]}
                      </S.Button>
                  )}
                </>
                {
                  (role === ROLES.TEAMLEADER || role === ROLES.ADMIN) && <S.BanComponent>
                  {visitorIsBanned ? (
                    <S.Button onClick={() => handleBanUnbanVisitor({unban: true})}>Unban</S.Button>
                  ) : (
                    <S.Button
                      onClick={() => setIsOpenedBanContent((prev) => !prev)}
                    >
                      Ban
                    </S.Button>
                  )}
                  {isOpenedBanContent && !visitorIsBanned && (
                    <ClickOutside onOutsideClick={() => setIsOpenedBanContent(false)} >
                      <S.BanContent>
                        <Paper elevation={24} className="ban-content">
                          <TextField
                            label="Reason"
                            placeholder="Reason"
                            variant="outlined"
                            defaultValue=""
                            size="small"
                            onChange={(e) => setReason(e.target.value)}
                          />
                          <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={banDuration || ''}
                            onChange={(_e, value) => setBanDuration(value)}
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio />}
                              label="1 Day"
                            />
                            <FormControlLabel
                              value="7"
                              control={<Radio />}
                              label="7 Day"
                            />
                            <FormControlLabel
                              value="1000000"
                              control={<Radio />}
                              label="Always"
                            />
                          </RadioGroup>
                          <S.Button onClick={() => handleBanUnbanVisitor()}>
                            Ban Visitor
                          </S.Button>
                        </Paper>
                      </S.BanContent>
                    </ClickOutside>
                  )}
                </S.BanComponent>
                }
              </S.RowContainer>
              <S.Referrers>
                {visitorInfo.referrers?.length && visitorInfo.referrers.map((referrer) => (
                  <span key={getDefaultId()}>{referrer}</span>
                ))}
              </S.Referrers>
              <S.UserComputerData className={cn({ UserComputerData: true })}>
                <S.DataItem >
                  <div>Location</div>
                  <div>{visitorInfo?.location || "-----"}</div>
                </S.DataItem>
                <S.DataItem>
                  <div>Browser</div>
                  <div>{browserName ? `${browserName}${browserVersion ? ` ${browserVersion}` : ''}` : "-----"}</div>
                </S.DataItem>
                <S.DataItem>
                  <div>Platform</div>
                  <div>{visitorInfo?.userAgent?.split('(')[1]?.split(';')[0] || "-----"}</div>
                </S.DataItem>
                <S.DataItem>
                  <div>Ip Address</div>
                  <div>{visitorInfo.ip || "-----"}</div>
                </S.DataItem>
                <S.DataItem>
                  <div>User Agent</div>
                  <div>{visitorInfo.userAgent || "-----"}</div>
                </S.DataItem>
              </S.UserComputerData>
            </S.ColumnContainer>
          </>
        )}
      </S.UserInfoContainer>
    );
  };